import * as React from "react";
import { ToggleBtn } from "../toggler/theme-toggler";
import { StaticImage } from "gatsby-plugin-image";
import { FaLinkedin } from "react-icons/fa";
import { RiMenu3Fill, RiCloseFill } from "react-icons/ri";

import { Link, useStaticQuery, graphql } from "gatsby";

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  const [navbarOpen, setNavbarOpen] = React.useState(false);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row justify-between items-center w-100 pt-10">
        <Link to="/">
          <div className="flex flex-row items-center">
            <StaticImage
              className="w-12 sm:w-16 sm:block"
              alt="Logo busy as a bee"
              src="../../images/busybee-logo.png"
            />
            <div className="ml-3 text-md sm:text-lg font-bold">
              {data.site.siteMetadata.title}
            </div>
          </div>
        </Link>
        <div className="flex flex-row">
          <div className="hidden sm:flex sm:flex-row sm:items-center text-sm sm:text-md">
            <Link
              to="/"
              activeClassName="active"
              className="font-bold fromLeft menu-link"
            >
              HOME
            </Link>
            <Link
              to="/about"
              activeClassName="active"
              className="font-bold ml-5 fromLeft menu-link"
            >
              A PROPOS
            </Link>
            <Link to="/resources" activeClassName="active" className="font-bold ml-5 fromLeft menu-link">
              RESSOURCES
            </Link>
            <Link
              to="/blog"
              activeClassName="active"
              className="font-bold ml-5 fromLeft menu-link"
            >
              BLOG
            </Link>
            <Link
              target="_blank"
              className="hidden sm:block"
              to="https://www.linkedin.com/in/natacha-rome-a218ab165/"
            >
              <FaLinkedin
                size={28}
                color="primary"
                className="mr-2 ml-6 hover:text-indigo-500  hover:scale-110"
              />
            </Link>
          </div>
          <div className="flex flex-row">
            <ToggleBtn />
            <div className="flex sm:hidden">
              <div className="flex flex-row align-center justify-center">
                <div
                  className="mt-3 text-text-main"
                  onClick={() => setNavbarOpen(!navbarOpen)}
                >
                  {navbarOpen && <RiCloseFill size={24} color="text-main" />}
                  {!navbarOpen && <RiMenu3Fill size={24} color="text-main" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex sm:hidden h-full">
        {navbarOpen && (
          <div className="flex flex-col h-20 mt-3">
            <Link to="/" activeClassName="active" className="font-bold ">
              HOME
            </Link>
            <Link to="/about" activeClassName="active" className="font-bold">
              A PROPOS
            </Link>
            <Link to="/resources" activeClassName="active" className="font-bold">
              RESSOURCES
            </Link>
            <Link to="/blog" activeClassName="active" className="font-bold">
              BLOG
            </Link>
            <Link
              target="_blank"
              className="hidden sm:block"
              to="https://www.linkedin.com/in/natacha-rome-a218ab165/"
            >
              <FaLinkedin
                size={28}
                color="primary"
                className="ml-6 hover:text-indigo-500  hover:scale-110"
              />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
